import React from "react";
import loader from "svg-loaders/svg-css-loaders/three-dots.svg";
const Loader = () => (
    <span className="icon"><img alt="loader" src={loader} /></span>
)
export default Loader;

